import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSettings } from '../utils/db';

const PlayRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const settings = getSettings();
    const availableGames = ['scratch', 'spin', 'peel', 'slot', 'flip'];
    
    if (settings.modeBehavior === 'random') {
      const randomGame = availableGames[Math.floor(Math.random() * availableGames.length)];
      navigate(`/${randomGame}`, { replace: true });
    } else {
      const target = settings.activeGame || 'scratch';
      navigate(`/${target}`, { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center p-6 text-white text-center">
      <div className="w-10 h-10 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin mb-4"></div>
      <p className="text-slate-400 text-sm">Connecting to active campaign...</p>
    </div>
  );
};

export default PlayRedirect;
